import React from "react";
import { Switch } from "antd";

import * as S from "./styles";
import { TProcessorSelector } from "./types";

const ProcessorSelector: React.FC<TProcessorSelector> = ({
  title,
  checkedCards,
  checkedDock,
  onCheckCards,
  onCheckDock,
}) => {
  return (
    <S.Container>
      <S.Content>
        <S.Wrapper>
          <S.Title>{title}</S.Title>
          <S.SwitchWrapper>
            <S.SwitchAndTextContainer>
              <Switch checked={checkedDock} onChange={onCheckDock} />
              <S.SwitchText>Dock</S.SwitchText>
            </S.SwitchAndTextContainer>

            <S.SwitchAndTextContainer>
              <Switch checked={checkedCards} onChange={onCheckCards} />
              <S.SwitchText>Cards</S.SwitchText>
            </S.SwitchAndTextContainer>
          </S.SwitchWrapper>
        </S.Wrapper>
      </S.Content>
    </S.Container>
  );
};

export default ProcessorSelector;
